import { memo, useEffect, useRef } from 'react';
import { useMapContext } from '../../hooks';
import { BOUNDS_ANIMATION } from '../animation';
/**
 * Компонент для работы с bounds карты
 */
var MapBounds = function (_a) {
    var bounds = _a.bounds, _b = _a.options, options = _b === void 0 ? BOUNDS_ANIMATION : _b;
    var map = useMapContext();
    var ref = useRef(options);
    useEffect(function () {
        ref.current = options;
    }, [options]);
    useEffect(function () {
        if (bounds) {
            map.setBounds(bounds, ref.current);
        }
    }, [bounds, map]);
    return null;
};
export default memo(MapBounds);
